import { css } from 'lit';

export const style = css`
  .alert-sticky {
    position: sticky;
    top: 0;
    /* Sits above app tiles and accordions but below modal overlays */
    z-index: 995;
  }

  .apps-list-container {
    margin: 1.25rem;
    display: flex;
    flex-direction: column;
    min-height: 800px;
  }

  .apps-list-container--header {
    text-align: center;
    margin: 1rem 0 2rem 0;
  }

  .mobile-view {
    display: inline;
  }

  .desktop-view {
    display: none;
  }

  .current-app {
    margin-bottom: 0.5rem;
  }

  .start-new-application {
    font-size: 1.25rem;
  }

  .other-apps {
    margin-top: 2rem;
  }

  .other-apps--header {
    font-size: 1.25rem;
  }

  @media (min-width: 600px) {
    .apps-list-container {
      margin: 1em auto 2em;
      max-width: 768px;
      align-items: center;
      padding: 0 1.5rem;

      .mobile-view {
        display: none;
      }

      .desktop-view {
        display: inline;
      }

      .start-new-application {
        width: 328px;
      }

      .other-apps {
        width: 100%;
      }
    }
  }
`;
